<template>
    <main class="mt-5">
        <div class="card wearehouse-card mt-3">
            <div class="card-header wearehouse-card__header border-0">
                <div class="wearehouse-card__header-left">
                    <div class="wearehouse-card__icon">
                        <i class="feather icon-box" aria-hidden="true"></i>
                    </div>
                    <div>
                        <h5 class="card-title font-bold mb-0">انبار گردانی محصولات</h5>
                        <div class="text-muted small">مقدار موجودی هر تنوع را وارد کنید</div>
                    </div>
                </div>

                <div class="wearehouse-card__header-right" />
            </div>

            <div class="card-body">
                <div class="row">
                    <!-- Empty state -->
                    <div v-if="!product" class="w-100 wearehouse-empty">
                        <div class="wearehouse-empty__box">
                            <i class="feather icon-file-text" aria-hidden="true"></i>
                            <div class="mt-3 font-weight-bold">محصولی انتخاب نشده است</div>
                            <div class="text-muted small mt-1">از بخش جستجو محصول را انتخاب کنید.</div>
                        </div>
                    </div>

                    <!-- Table -->
                    <div v-else class="w-100">
                        <div class="table-responsive wearehouse-table-wrap">
                            <table class="table wearehouse-table mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 70px;">ردیف</th>
                                        <th>عنوان</th>
                                        <th style="min-width: 160px;">بارکد</th>
                                        <th class="text-center" style="width: 160px;">قیمت(تومان)</th>
                                        <th class="text-center" style="width: 180px;">موجودی</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(variety,index) in product.varieties"
                                        :key="index"
                                    >
                                        <td class="text-center font-weight-bold">{{ index + 1 }}</td>
                                        <td>
                                            <div class="wearehouse-title">{{ variety.full_name }}</div>
                                        </td>
                                        <td>
                                            <div class="wearehouse-code">{{ variety.barcode }}</div>
                                        </td>
                                        <td class="text-center">
                                            <span class="wearehouse-price">{{ variety.price | price}}</span>
                                        </td>
                                        <td class="text-center">
                                            <b-form-input
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-model.number="variety.quantity"
                                                class="wearehouse-input"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="wearehouse-hint mt-3">
                            <i class="feather icon-info" aria-hidden="true"></i>
                            <span>مقدار موجودی را برای هر ردیف وارد کنید سپس دکمه انبار گردانی را بزنید.</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-footer border-0" v-if="product">
                <div class="wearehouse-footer d-flex justify-content-center align-items-center">
                    <button
                        class="btn btn-success wearehouse-submit"
                        :disabled="disabled"
                        @click="submitData"
                    >
                        <i class="feather icon-save" aria-hidden="true"></i>
                        <span class="mr-2">انبار گردانی</span>
                    </button>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import WearehouseManagementLmpl from '@@/core/pages/WearehouseManagement/WearehouseManagementLmpl'
export default {
    extends: WearehouseManagementLmpl
}
</script>

<style scoped>
/* Header */
.wearehouse-card {
    border-radius: 14px;
    overflow: hidden;
}

.wearehouse-card__header {
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.14), rgba(34, 197, 94, 0.06));
    padding: 18px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.wearehouse-card__header-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.wearehouse-card__icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(16, 185, 129, 0.12);
    color: #10b981;
    flex: 0 0 42px;
}

.wearehouse-empty {
    min-height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.wearehouse-empty__box {
    width: 100%;
    max-width: 520px;
    border: 1px dashed rgba(0, 0, 0, 0.12);
    background: rgba(0, 0, 0, 0.02);
    border-radius: 16px;
    padding: 28px 18px;
    text-align: center;
}

.wearehouse-empty__box i {
    font-size: 28px;
    color: rgba(16, 185, 129, 0.9);
}

/* Table */
.wearehouse-table-wrap {
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
}

.wearehouse-table {
    width: 100%;
    font-size: 0.95rem;
}

.wearehouse-table thead th {
    background: #f6f8fb;
    color: #334155;
    font-weight: 700;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
    padding: 14px 14px;
    white-space: nowrap;
}

.wearehouse-table tbody td {
    padding: 12px 14px;
    vertical-align: middle;
    border-top: 1px solid rgba(0, 0, 0, 0.04);
}

.wearehouse-table tbody tr {
    transition: background 0.15s ease;
}

.wearehouse-table tbody tr:nth-child(even) {
    background: rgba(16, 185, 129, 0.02);
}

.wearehouse-table tbody tr:hover {
    background: rgba(16, 185, 129, 0.06);
}

.wearehouse-title {
    font-weight: 700;
    color: #0f172a;
}

.wearehouse-code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 0.9rem;
    color: #475569;
}

.wearehouse-price {
    font-weight: 800;
    color: #16a34a;
}

/* Input */
.wearehouse-input {
    display: inline-block;
    width: 120px;
    text-align: center;
    border-radius: 12px;
    padding: 10px 12px !important;
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
    background: #fff;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.wearehouse-input:focus {
    border-color: rgba(16, 185, 129, 0.55) !important;
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.18);
    outline: none;
}

.wearehouse-hint {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px 14px;
    border-radius: 14px;
    border: 1px solid rgba(16, 185, 129, 0.18);
    background: rgba(16, 185, 129, 0.06);
    color: #065f46;
}

.wearehouse-hint i {
    font-size: 18px;
}

/* Footer button */
.wearehouse-footer {
    padding: 16px 20px;
    background: #fff;
}

.wearehouse-submit {
    min-width: 220px;
    border-radius: 14px;
    padding: 10px 18px;
    box-shadow: 0 10px 20px rgba(34, 197, 94, 0.18);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.wearehouse-submit:disabled {
    opacity: 0.65;
    box-shadow: none;
}
</style>

